export const SET_LOADING = 'BEAMLY/SHOPPING-BAG/SET_LOADING';
export const SET_REMOVING = 'BEAMLY/SHOPPING-BAG/SET_REMOVING';
export const SET_ACTIVE_RETAILER = 'BEAMLY/SHOPPING-BAG/SET_ACTIVE_RETAILER';
